import { DesignSystemViewer } from './DesignSystemViewer'

export function AppPrototype(): JSX.Element {
  return (
    <DesignSystemViewer
      title="Prototipo de la aplicación"
      description="9 pantallas navegables que representan el MVP completo — fuente visual de verdad para cada ruta."
      src="/design-system/app-prototype.html"
    />
  )
}
